import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const WalletApi = {
  post: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/wallet/start-sync`, data, callback, setIsLoading)
  },
}
export default WalletApi
